export const api_base_url = process.env.REACT_APP_API_BASE_URL;

let version = 'v1'
let walleturl = `${api_base_url}/blockstats/walletservice/${version}`
let aggregatorurl = `${api_base_url}/blockstats/aggregator/${version}`
let aiTransactionUrl = `${api_base_url}/blockstats/ai/${version}`
let portfolio = `${api_base_url}/blockstats/portfolioservice/${version}`
let analytics = `${api_base_url}/blockstats/analyticsservice/${version}`
let defi = `${aggregatorurl}/defi`
let defiStaking = `${api_base_url}/blockstats/aggregator/${version}`
let userProfile = `${api_base_url}/blockstats/userservice/${version}`
let fileUploadService = `${api_base_url}/blockstats/file-upload-service/${version}`
let taxservice = `${api_base_url}/blockstats/taxservice/${version}`
let performance = `${api_base_url}/blockstats/performanceservice/${version}`
let payment = `${api_base_url}/blockstats/paymentservice/${version}`
let aiTxnLabelling = `${api_base_url}/blockstats/taxservice/${version}`

const ApiConfig = {
  wallet: `${walleturl}/wallets`,
  detectChains: `${walleturl}/wallets/dex-evm/chains`,
  walletMetrics: `${aggregatorurl}/wallets-metrics`,
  aiTransactions: `${aiTransactionUrl}/transactions`,
  aiTxnLabellingQuota: `${aiTxnLabelling}/aiTxnLabelling/quota`,

  //aggregator_services_api
  spotHoldings: `${aggregatorurl}/accounts`,
  openOrders: `${aggregatorurl}/orders`,
  transactions: `${aggregatorurl}/transactions`,
  transactionMetricsFilters: `${aggregatorurl}/transaction-metrics-filters`,
  transferReview: `${aggregatorurl}/transfer-review`,
  transferReviewKnownAddresses: `${aggregatorurl}/transfer-review/known-addresses`,
  transferReviewAddressGroups: `${aggregatorurl}/transfer-review/address-groups`,
  transferReviewAddressGroupsConfirm: `${aggregatorurl}/transfer-review/address-groups/confirm`,
  transferReviewAddressGroupsDismiss: `${aggregatorurl}/transfer-review/address-groups/dismiss`,
  taxHealth: `${aggregatorurl}/tax-health`,
  taxLossHarvest: `${aggregatorurl}/tax-loss-harvest`,

  //margins: `${aggregatorurl}/margins`,
  futures: `${aggregatorurl}/futures`,

  //performance
  allHoldings: `${performance}/asset/all-holdings`,
  performanceMetrics: `${performance}/metrics`,
  currentHoldings: `${performance}/asset/current-holdings`,

  //portfolio_services_api
  load: `${portfolio}/portfolio/sync`,
  walletStatus: `${portfolio}/status`,
  unrealizedGain: `${performance}/portfolio/unrealized-gains`,
  bestPerformer: `${analytics}/portfolio/best-performer`,
  allocation: `${analytics}/portfolio/allocation`,
  performance: `${analytics}/performance/chart`,

  //aggregator_defi_services_api
  defiAccounts: `${defi}/accounts`,
  defiTransactions: `${defi}/transactions`,
  defiStakings: `${defiStaking}/defi/liquidity`,
  defiNetworks: `${aggregatorurl}/accounts`,
  nft: `${defiStaking}/defi/nft`,

  //api_to_get_current_balances
  currentBalance: `${aggregatorurl}/accounts`,
  currentBalancePercentage: `${aggregatorurl}/accounts/currentBalancePercentage`,
  marginsBalance: `${aggregatorurl}/margins/currentBalance`,
  futuresBalance: `${aggregatorurl}/futures/currentBalance`,

  //analytics_services_api
  bubbleMap: `${analytics}/holding/bubble-view`,
  deposits: `${analytics}/summary/deposits`,
  withdrawal: `${analytics}/summary/withdraws`,
  summary: `${analytics}/summary/assets`,
  unlockTokens: `${analytics}/unlock-tokens`,

  //taxation
  realizedgains: `${analytics}/tax/realized-gains`,
  longRealizedgains: `${analytics}/tax/long-realized-gains`,
  totalBuy: `${analytics}/tax/total-buy`,
  totalSell: `${analytics}/tax/total-sell`,
  transactionCount: `${analytics}/tax/transaction-count`,
  taxDeducted: `${analytics}/tax/tax-deducted`,
  pdfGeneration: `${analytics}/tax/generate-pdf`,
  tax: `${taxservice}/tax`,
  aiTxnLabelling: `${aiTxnLabelling}/aiTxnLabelling`,

  //topbar
  country: `${aggregatorurl}/country`,

  //userprofile
  userProfile: `${userProfile}/users`,
  userOnboard: `${userProfile}/users/onboard`,

  //fileUpload
  fileUpload: `${fileUploadService}/files`,

  //costBasis
  costBasis: `${aggregatorurl}/transactions`,

  paymentPlans: `${payment}/subscriptionplans`,
  chargebeeCheckout: `${payment}/checkout/chargebee`,
  activeUserSubscription: `${payment}/users/subscriptions/active`,
  allSubscriptions: `${payment}/users/subscriptions`,
  paymentInvoicesDownloads: `${payment}/users/payments/invoices`,

  //CPA portal
  accountantClients: `${userProfile}/accountant/clients`,
  accountantInvites: `${userProfile}/accountant/invites`,
  taxAccountantView: `${taxservice}/tax/accountant-view`,
  accountantTeamMembers: `${userProfile}/accountant/team/members`,
  accountantTeamInvites: `${userProfile}/accountant/team/invites`,
  accountantActivate: `${userProfile}/accountant/activate`,
  // Client-facing side of the CPA portal - "who has access to ME", not "who I have access to"
  accountantMyAccess: `${userProfile}/accountant/my-access`,
  // Server-generated reset link emailed via Resend - replaces Firebase's own default email
  // sender (poor Gmail deliverability), see RecoverPassword.js/PasswordRecovery.js
  passwordReset: `${userProfile}/auth/password-reset`,
  // Our own token verify+set-password step - replaces Firebase's confirmPasswordReset, since
  // Email Enumeration Protection on this project suppresses generatePasswordResetLink's oobCode,
  // see PasswordResetService.java and CreateNewPassword.js
  passwordResetConfirm: `${userProfile}/auth/password-reset/confirm`,
}

export default ApiConfig